import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthBagService } from './auth-bag.service';
import { Observable, of, from, map, catchError } from 'rxjs';
import { AuthService } from './auth.service';
import { Permissions } from '@/common/enums/Permissions';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
	constructor(
		private readonly authBagService: AuthBagService,
		private readonly authService: AuthService,
		private readonly router: Router,
	) {}

	canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
		if (this.authBagService.authStatus$.getValue()) {
			return of(this.resolvePilotsAccessRoute(state.url));
		}

		const access = this.authBagService.tokenGet();
		const refresh = this.authBagService.tokenRefreshGet();

		if (access && refresh) {
			return from(this.authBagService.authenticate({ access, refresh })).pipe(
				map((success) => {
					if (!success) {
						return this.router.createUrlTree(['/login']);
					}
					return this.resolvePilotsAccessRoute(state.url);
				}),
				catchError(() => of(this.router.createUrlTree(['/login']))),
			);
		}

		return of(this.router.createUrlTree(['/login']));
	}

	private resolvePilotsAccessRoute(url: string): boolean | UrlTree {
		if (!this.authService.permissionsByCode()[Permissions.TOURISM_GUIDES_FILE_ACCESS]) {
			return true;
		}

		if (url === '/tourism-guides-file-list' || /^\/tourism-guides-file-list\/[^/]+\/edit$/.test(url)) {
			return true;
		}

		return this.router.createUrlTree(['/tourism-guides-file-list']);
	}
}
